import React from 'react';

import digitalCertificate from '../../assets/certificado-digital-2.png';
import digitalCertificateICP from '../../assets/icp.png';
import digitalCertificateSafeWeb from '../../assets/safeweb.png';

const Certificate: React.FC = () => (
  <>
    <div className="container">
      <div className="row align-items-center">
        <div className="col certificate text-center">
          <img src={digitalCertificate} alt="Certificado Digital" />
        </div>
        <div className="col certificate text-center">
          <a href="https://www.gov.br/iti/pt-br/assuntos/icp-brasil" target="_blank" rel="noreferrer" title="ICP-Brasil">
            <img src={digitalCertificateICP} alt="ICP-Brasil" />
          </a>
        </div>
        <div className="col certificate text-center">
          <a href="https://safeweb.com.br/" target="_blank" rel="noreferrer" title="SafeWeb">
            <img src={digitalCertificateSafeWeb} alt="SafeWeb" />
          </a>
        </div>
      </div>
    </div>
  </>
);

export default Certificate;
